export default "__VITE_ASSET__DNEfpl_8__"